import { cn } from "@bem-react/classname";
import { selectSubject } from "modules/Subject";
import { getGroups, getPortals, IGroups, IPortal, IPupilGroup, selectTeacherJournal, setGroup } from "modules/TeacherJournal";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDomain, getExamName } from "utils";
import './PortalList.scss'
import Help from 'components/Help'

interface ISubject {
    name: string,
    title: string,
    groups: IGroups
}

const Group: FC<{group: IPupilGroup}> = ({group}) => {
    const cnpl = cn('PortalList')
    const state = useSelector(selectTeacherJournal)
    const dispatch = useDispatch()
    const curSel = state.options.selectedGroup!
    let classn 
    if (curSel?.id === group.id && curSel.portal === group.portal && curSel.subject === group.subject){
        classn = cnpl('Group selected')
    } else {
        classn = cnpl('Group')
    }
    
    return <div className={classn} onClick={()=>dispatch(setGroup({portal: group.portal, subject: group.subject, id: group.id}))}>{group.name}</div>
}

const Subject: FC<{subject: ISubject}> = ({subject}) => {
    const cnpl = cn('PortalList')
    const [showArchive, setShowArchive] = useState(subject.groups.filter((g) => g.id > 0 && g.archive === 1).length? 0:1)
    
    return <div className={cnpl('Subject')}>
        <h3 className={cnpl('Title')}>Выберите группу</h3>
        {/*<span className={cnpl('SubjectName')}>{subject.title}:</span>*/}
        <div className={cnpl('Groups')}>
            {subject.groups.filter((g) => g.id > 0 && g.archive === 0).map((group, index) => (<Group key={index} group={group}/>))}
        </div>
        <div className={cnpl('Groups noGroup')}>
            {subject.groups.filter((g) => g.id === -1).map((group, index) => (<Group key={index} group={group}/>))}
        </div>
        {showArchive?
            <div className={cnpl('Groups Archive')}>
                {subject.groups.filter((g) => g.id > 0 && g.archive === 1).map((group, index) => (<Group key={index} group={group}/>))}
            </div>:
            <div className={cnpl('ShowArchive')} onClick={()=>{setShowArchive(1)}} title={"Показать архивные группы"}>+</div>
        }
    </div>
}

const Portal: FC<{portal: IPortal}> = ({portal}) => {
    const state = useSelector(selectTeacherJournal)
    const cnpl = cn('PortalList')
    let subjects = [] as Array<ISubject>;
    const curSubj = useSelector(selectSubject)
    const [expanded, setExpanded] = useState(curSubj?.name)
    for (let subj in portal?.subjects) {
        subjects.push({name: subj, title: portal.subjects[subj], groups: getGroups(state, portal.id, subj)})
    }
    const activeSubj = subjects.filter(i=>i.name===expanded).pop()
    return <div className={cnpl('Portal')}>
        {subjects.length > 0 && <h3 className={cnpl('Title')}>Предмет</h3>}
        <div className={cnpl('Subjects')}>
            {subjects.map((subject, index) => (
                <div key={index} onClick={()=>setExpanded(subject.name)} className={cnpl('SubjectHidden')+(subject.name===expanded?' active':'')}>
                    <span className={cnpl('SubjectName')}>{subject.title}</span>
                </div>
            ))
            }
        </div>
        {activeSubj?
        <Subject subject={activeSubj}/>
        :""}
        
    </div>
    
}

const PortalList: FC = () => {
    const state = useSelector(selectTeacherJournal)
    const portals = getPortals(state);
    const cnpl = cn('PortalList')
    const domain = useSelector(getDomain)
    const exam = getExamName(domain)
    const [expanded, setExpanded] = useState(exam as string)
    
    return <div className={cnpl()}>
        <span style={{display: 'block'}}>
            <h3 className={cnpl('Title')} style={{display: 'inline-block'}}>Выберите портал</h3>
            <Help name="journal"/>
        </span>
        {portals.availablePortals.map((p, index)=>(
            <div key={index} onClick={()=>setExpanded(p.id)} className={cnpl('PortalHidden')+(p.id===expanded?' active':'')}>
                <span className={cnpl('PortalName')}>{p.name.replace('РЕШУ ', '')}</span>
            </div>
        ))}
        {portals.unavailablePortals.map((p, index)=>(
            <div key={p.name} className={cnpl('PortalHidden')+' unavailable'}>
                <span className={cnpl('PortalName')}>{p.name.replace('РЕШУ ', '')}</span>
            </div>
        ))}
        <Portal portal={portals.availablePortals.filter(i=>i.id===expanded).pop()!}/>
    </div>
}

export default PortalList